import { TextCell } from '@common/components/TextCell';

interface OrderIdCellProps {
	orderId: string;
	orderNumber?: number;
}

export const OrderIdCell = ({ orderId, orderNumber }: OrderIdCellProps) => {
	// Display order number if available, fallback to truncated UUID
	const displayValue = orderNumber ? `#${orderNumber}` : orderId.substring(0, 8);

	return <TextCell value={displayValue} weight='semibold' />;
};
